import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockBehaviorDataType } from "../../../../../enums/SDKDocsBlockBehaviorDataType";
import { DocsBlockBehaviorSelectionType } from "../../../../../enums/SDKDocsBlockBehaviorSelectionType";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { descriptionFull, descriptionShort, docsUrl, icon, id, keywords, name, } from "../files/SDKDocsBlockActualFiles";
const b = new DocsBlockBuilder();
/**
 * 2. Block properties
 */
const properties = {
    files: b.fileProperty({
        id: "files",
        name: "Files",
        options: {
            renderLayoutAs: "iconOnLeft",
            editorInteractivity: "viewOnly",
        },
        variants: {
            iconOnLeft: {
                renderLayoutAs: "iconOnLeft",
            },
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.variantUsingDefaultLayout({
    id: "iconOnLeft",
    name: "Icon on left",
    image: "https://cdn-assets.supernova.io/blocks/variants/files-leading-icon.svg",
    properties: [properties.files],
    maxColumns: 2,
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.files],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.dataBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.media,
    description: descriptionShort,
    searchKeywords: keywords,
    dataType: DocsBlockBehaviorDataType.file,
    selectionType: DocsBlockBehaviorSelectionType.entity,
    item: blockItem,
    onboarding: b.onboarding({
        helpText: descriptionFull,
        documentationLink: docsUrl,
    }),
    appearance: {
        isBordered: false,
    },
});
/** 6. Block export */
export { block as Files };
